import styles from './Table.module.scss';

import clsx from 'clsx';

export const Table: React.FC<React.HTMLProps<HTMLDivElement>> = (props) => {
  const { children, className, ...rest } = props;
  return (
    <div className={clsx(styles.table, className)} tabIndex={-1} {...rest}>
      {children}
    </div>
  );
};
